import './public-path'
// 防止 polyfill 引用多次报错的问题
import 'common-mediax/src/style/index.scss'
import 'idempotent-babel-polyfill'
import 'common-mediax/src/common/secure-storage-patch.js'
import Vue from 'vue'
import cdnConfig from '../../../config/cdnConfigWeb'
import EventBus from 'common-mediax/src/common/EventBus'
import GlobalEvent, { EventBusDataKey } from '@common/GlobalEvent'
import { router, routes } from './router'
import ElementUI from 'common-mediax/src/element-ui'
let tempConfig = Object.assign({}, cdnConfig)
delete tempConfig.host
Object.assign(window.CDN_CONFIG, tempConfig)
// import store from './store'
import store from 'common-mediax/src/store'

import App from './App.vue'
import IconSvg from 'common-mediax/src/components/IconSvg'

// import 'common-mediax/src/assets/css/var.scss'
// import './assets/css/common.scss'

import 'common-mediax/src/style/common-article.scss'
import { start } from 'qiankun'
import permission from './permission'
import '@common/DialogDrag.js'
// img标签转svg
import '@iconfu/svg-inject'
import 'common-mediax/src/common/DialogWatcherPlugin'
Vue.use(window.dialogWatcherPlugin)
// 全局事件总线
EventBus.install(Vue)
// 全局事件总线事件名称
Vue.prototype.$globalEvent = GlobalEvent
// 全局数据key
Vue.prototype.$eventBusDataKey = EventBusDataKey
SVGInject.setOptions({
  beforeInject: function (img, svg) {
    svg.fill = ''
    let html = svg.innerHTML
    html = html.replace(/fill="(.*?)"/g, '')
    svg.innerHTML = html
    return svg
  }
})

Vue.use(ElementUI, { size: 'small' })
Vue.component('IconSvg', IconSvg)

// eslint-disable-next-line
let globalSocket = null

/**
 * 判断是否是主应用路由
 * @param path 当前路由
 * @returns {boolean}
 */
function isMainRoute(path) {
  // 将主路由过滤掉service和open以及根目录
  const mainRoute = routes.filter((item) => {
    if (
      !item.path.includes('service') &&
      !item.path.includes('open') &&
      item.path !== '/'
    ) {
      return true
    } else {
      return false
    }
  })
  return mainRoute.some((item) => path.startsWith(item.path))
}
// 缓存主应用的appendChild和addEventListener
const rawAppendChild = HTMLHeadElement.prototype.appendChild
const rawAddEventListener = window.addEventListener
router.beforeEach((to, from, next) => {
  // console.log(from.path, to.path)
  //如果当前路由是子项目，并且去的路由是父项目的，则还原这两个对象
  if (!isMainRoute(from.path) && isMainRoute(to.path)) {
    // console.log('从微服务进入主应用路由')
    HTMLHeadElement.prototype.appendChild = rawAppendChild
    window.addEventListener = rawAddEventListener
  }
  let loginInfo = localStorage.getItem('loginInfo')
  let messageShowPopup = true
  if (window.localStorage.getItem('messageShowPopup') !== null) {
    messageShowPopup = JSON.parse(
      window.localStorage.getItem('messageShowPopup')
    )
  }
  try {
    loginInfo = JSON.parse(loginInfo)
  } catch (err) {
    console.log(err)
  }
  // 判断是否云端稿库
  const isRR = process.env.MODE === 'RR'
  // 判断是否PUGC投稿平台
  const isPUGC = process.env.MODE === 'PUGC'
  if (
    !isPUGC &&
    !isRR &&
    loginInfo &&
    loginInfo.userID &&
    messageShowPopup &&
    to.name !== 'Login'
  ) {
    initSocketEvents(loginInfo.userID)
  }
  next()
})
function initSocketEvents(userID) {
  if (globalSocket && globalSocket.readyState === WebSocket.OPEN) {
    return // WebSocket 已经连接，无需重新连接
  }
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
  const wensocketDomain =
    window.location.hostname.indexOf('localhost') > -1
      ? 'apis-mediax.devx.fzyun.io'
      : window.location.hostname.replace('web-', 'apis-')
  globalSocket = new WebSocket(
    `${protocol}://${wensocketDomain}/mediax-articlemy/websocket/user/${userID}`
  )
  globalSocket.addEventListener('open', () => {
    console.log('WebSocket connection established')
  })

  // globalSocket.addEventListener('error', (err) => {
  //   console.error('WebSocket error:', err);
  //   // 可根据需要实现更复杂的重试策略，如指数退避等
  //   setTimeout(() => {
  //     initSocketEvents(userID);
  //   }, 3000); // 3秒后尝试重连
  // });

  // 监听新消息事件
  globalSocket.addEventListener('message', (event) => {
    // const message = JSON.parse(event.data);
    const message = event.data
    handleNewMessage(message)
  })

  function handleNewMessage(message) {
    // 在这里处理新消息，如更新状态、触发通知等
    // 存储新消息到 Vuex store
    if (store) {
      store.dispatch('globalMessages/receiveMessage', message)
    }

    // 触发全局事件，通知所有子应用有新消息到来
    window.dispatchEvent(new CustomEvent('newMessage', { detail: message }))
  }

  Vue.prototype.$socket = globalSocket
}

/**
 * 把共享的 vuex store 放到 kjqk-commons/src/store/micro-module.js
 * 以便于所有的子应用都能引用，并能单独启动项目
 */
import * as micro from 'common-mediax'
import { microModule, register } from 'common-mediax'
import buildTime from './common/buildTime'
// import 'common-mediax/src/assets/css/e5.scss'
Vue.config.productionTip = false
Vue.config.$micro = micro
Vue.prototype.$buildTime = window.YQ_buildTime = buildTime

store.registerModule('micro', microModule)

permission(store, router)
console.log('----MODE-----', process.env.MODE)
window.processEnvMode = process.env.MODE || undefined
Vue.component('RemoteScript', {
  render: function (createElement) {
    var self = this
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.src
      },
      on: {
        load: function (event) {
          self.$emit('load', event)
        },
        error: function (event) {
          self.$emit('error', event)
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event)
          }
        }
      }
    })
  },

  props: {
    src: {
      type: String,
      required: true
    }
  }
})

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
// 微服务是否注册完成
let microInstall = false
new Vue({
  router,
  store,
  render: (h) => h(App),
  async mounted() {
    // 获取最外层容器
    const targetNode = document.getElementById('app')
    // 观察子节点的变化
    const config = { childList: true, subtree: true }
    // 节点变化回调方法
    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (document.querySelector('#container') && !microInstall) {
          // 当检测到container容器后，同时微服务没有注册过，执行微服务注册，将注册状态设置为true，避免重复注册
          microInstall = true
          // 获得地址
          const resetApps = {}
          register(microModule, store, resetApps)
          if (!window.qiankunStarted) {
            window.qiankunStarted = true
            start({
              singular: false,
              // FIXME 暂时关闭prefetch选项，避免未启动的服务报错
              prefetch: false,
              excludeAssetFilter: (url) => {
                return (
                  // 135编辑器的内容不要删
                  url.indexOf('static/ueditor135') !== -1
                )
              }
            })
          }
          if (window.localStorage.getItem('paperCustomStyle') !== null) {
            if (JSON.parse(window.localStorage.getItem('paperCustomStyle'))) {
              document.getElementById('app').setAttribute('class', 'them_tmly')
            } else {
              document.getElementById('app').removeAttribute('class')
            }
          }
          // 移除观察者
          observer.disconnect()
        }
      }
    }
    // 注册观察者
    const observer = new MutationObserver(callback)
    // 启动观察者
    observer.observe(targetNode, config)
  }
}).$mount('#app')
